module.exports = __webpack_public_path__ + "img/left-arm.93a2e906.png";